// extracted by mini-css-extract-plugin
export var displayNone = "_qu-6";
export var imgContainer = "_qu-2";
export var overflowHidden = "_qu-3";
export var productInfoCardButtonContainer = "_qu-5";
export var productTitleText = "_qu-4";
export var rightArrow = "_qu-1";
export var rightArrowContainer = "_qu-0";